export default __webpack_public_path__ + "static/media/learose3-768w.dfc63d42.avif";